import axios from 'axios';
import { Message } from 'element-ui';
import store from '../store';
import { getToken } from '@/utils/auth';
import qs from 'qs';


// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
      if (config.method === 'PUT') {
        // const qs = requrie('qs')
        config.data = qs.stringify(config.data);
      }
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log('debugerror', error); // for debug
    Promise.reject(error);
  }
);
function handleResponseCode(res) {
  // user login
  if (res.code == 10404) {
    store.dispatch('FedLogOut').then(() => {
      location.reload(); // 为了重新实例化vue-router对象 避免bug
    });
    return;
  }
  if (res.code == 11403) {
    store.dispatch('FedLogOut').then(() => {
      location.reload(); // 为了重新实例化vue-router对象 避免bug
    });
    return;
  }
  if (res.code == 12403) {
    this.windows.location.href = '/';
    return;
  }
  Message({
    message: res.msg_show,
    type: 'error',
    duration: 3 * 1000
  });
  return Promise.reject(res);
}
// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    if (res.code < 200 && res.code >= 300) {
      return handleResponseCode(res);
    } else {
      return res;
    }
  },
  error => {
    if (error.response && error.response.data) {
      const res = error.response.data;
      return handleResponseCode(res);
    }
    Message({
      message: '数据请求发生错误',
      type: 'error',
      duration: 3 * 1000
    });
    return Promise.reject(error.response);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js